import { render, staticRenderFns } from "./offer.vue?vue&type=template&id=94455aa6&scoped=true&"
import script from "./offer.vue?vue&type=script&lang=js&"
export * from "./offer.vue?vue&type=script&lang=js&"
import style0 from "./offer.vue?vue&type=style&index=0&id=94455aa6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94455aa6",
  null
  
)

export default component.exports